import axios from './axios'

export function getGatewayList() {
  return axios({
    method: "get",
    url: '/api/v1/device/gateway/'
  })
}
export function createGateway(sub) {
  return axios({
    method: "post",
    url: '/api/v1/device/gateway/',
    data: sub
  })
}
export function deleteGateway(id) {
  return axios({
    method: "delete",
    url: '/api/v1/device/gateway/' + id + '/delete/'
  })
}
export function getSensorList() {
  return axios({
    method: "get",
    url: '/api/v1/device/tyre/'
  })
}
export function createSensor(sub) {
  return axios({
    method: "post",
    url: '/api/v1/device/tyre/',
    data: sub
  })
}
export function deleteSensor(id) {
  return axios({
    method: "delete",
    url: '/api/v1/device/tyre/' + id + '/delete/'
  })
}
export function getIdleGateway() {
  return axios({
    method: "get",
    url: '/api/v1/device/gateway/idle'
  })
}

export function getIdleTyre() {
  return axios({
    method: "get",
    url: '/api/v1/device/tyre/idle'
  })
}
